import { render, staticRenderFns } from "./RuleMaxWaitTime.vue?vue&type=template&id=febfc9f6"
import script from "./RuleMaxWaitTime.vue?vue&type=script&lang=js"
export * from "./RuleMaxWaitTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports